<template>
  <div>
    <div class="from-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un Tipo de Envio</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los Tipos de Envio</option>  
        <option v-for="(tipoEnvio,index) in tiposEnvio" :value="tipoEnvio.TipoEnvioId" :key="index">{{tipoEnvio.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
  	data() {
      return {
        enumeraciones,
        tiposEnvio: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods:{
    	cambiarDatos(evento){
	        this.idDelModelo = evento.target.value;
	        const valoresDelCatalogo =
	        {
	          llave: this.idDelInput,
	          valor: evento.target.value 
	        }

	        this.$store.dispatch("A_REGOP_Catalogos_003TiposEnvio",valoresDelCatalogo);
	        this.$emit("valorParaElPadre",evento);    		
    	},
    	cargarTiposEnvio: function(){
    		const SERVIDOR = api.conexion;
        	const METODO_API_AGREGAR = api.REGOP.catalogos.C003TiposEnvio;
        	let urlApi = SERVIDOR + METODO_API_AGREGAR;

        	if(this.parametros == null || this.parametros == undefined)
          		this.parametros = {};
        	
        	this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        	let peticionMetodoGetTiposEnvioAPI = this.parametros;

        	let peticionArchivos = false;
        	let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
        	comun.SeEstaCargandoInformacion(true); 

			axios.post(urlApi, peticionMetodoGetTiposEnvioAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        /* utilizar solo en etapa de desarrollo 
                        console.log("ejecuto bien paginas controller:: ",respuesta.data); */
                        this.tiposEnvio = respuesta.data.TiposEnvio;

                    if(this.parametros.elementosAOmitir != undefined){
                    	this.tiposEnvio = this.tiposEnvio.filter(element => {                   
                    		if(!this.parametros.elementosAOmitir.includes(element.TipoEnvioId))
                    			return element;
                    	});
                    }

                    if(this.parametros.elementosAConservar != undefined && this.parametros.elementosAConservar != null  && this.parametros.elementosAConservar.length > 0){
                     	this.tiposEnvio = this.tiposEnvio.filter(element => {                  
                    		if(this.parametros.elementosAConservar.includes(element.TipoEnvioId))
                    			return element;
                    	});
                    }



                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post         	
    	},
    },
    mounted(){
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_REGOP_Catalogos_003TiposEnvio", valoresDelCatalogo);    	
    },
    created() {
      this.cargarTiposEnvio();
    }
  }

	
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/REGOP/Catalogos/C003TiposEnvio.vue